export default __webpack_public_path__ + "static/media/1.07b97021.png";